import { z } from "zod";
import { SubSchema, SubsSchema } from "../paywall-js";
import { PublicWebProductSchema } from "./webProduct";
export const WebPaywallThemeSchema = z.object({});
export const WebPaywallSchema = z.object({
    id: z.number(),
    createdAt: z.string(),
    updatedAt: z.string(),
    identifier: z.string(),
    name: z.string(),
    url: z.string(),
    substitutions: z.array(SubSchema),
    applicationId: z.number()
});
export const PublicWebPaywallSchema = z.object({
    identifier: z.string(),
    url: z.string(),
    // What ranks are available for this paywall
    // used to determine which options to show in the UI
    stripe_product_ranks: z.array(z.number())
});
export const WebPaywallPresentationConfigurationSchema = z.object({});
export const WebPaywallResponseSchema = z.object({
    theme: WebPaywallThemeSchema,
    substitutions: SubsSchema,
    webProducts: z.array(PublicWebProductSchema),
    initialProductSelection: z.object({
        selectedPriceIndex: z.number(),
        selectedProductIndex: z.number().optional()
    }).optional()
});
